/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Nameminlength3Inputs */

const zh_organizationsettings_nameminlength3 = /** @type {(inputs: Organizationsettings_Nameminlength3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称至少需要1个字符`)
};

const en_organizationsettings_nameminlength3 = /** @type {(inputs: Organizationsettings_Nameminlength3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name must be at least 1 character`)
};

const es_organizationsettings_nameminlength3 = /** @type {(inputs: Organizationsettings_Nameminlength3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre debe tener al menos 1 carácter`)
};

/**
* | output |
* | --- |
* | "Name must be at least 1 character" |
*
* @param {Organizationsettings_Nameminlength3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_nameminlength3 = /** @type {((inputs?: Organizationsettings_Nameminlength3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Nameminlength3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_nameminlength3(inputs)
	if (locale === "en") return en_organizationsettings_nameminlength3(inputs)
	return es_organizationsettings_nameminlength3(inputs)
});
export { organizationsettings_nameminlength3 as "organizationSettings_nameMinLength" }